export default {
  title: '¡Actualización de hora!',
  labels: {
    old_time: 'Hora de recogida anterior:',
    new_time: 'Nueva hora de recogida:',
  },
  buttons: {
    print: 'Imprimir y cerrar',
    got_it: 'Entendido',
  },
  feedback: {
    new_prep_time: 'El tiempo de entrega se ha actualizado. Ajusta tu planificación de preparación en consecuencia.',
  },
  toasts: {
    something_went_wrong: 'Algo salió mal, inténtalo de nuevo',
  },
};
